import "./Home.module.css";
import ClinicHeader from "@/reusable_sections/Header";
import YourHealthcareAlly from "./sections/YourHealthcareAlly";
import TrustedByProsAndHomeowners from "./sections/TrustedByProsAndHomeowners";
import TheSomnaDifference from "./sections/TheSomnaDifference";
import VoicesOfResilience from "./sections/VoicesOfResilience";
import SecureYourStrategy from "./sections/SecureYourStrategy";
import PatientResources from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <ClinicHeader />
      <YourHealthcareAlly />
      <TrustedByProsAndHomeowners />
      <TheSomnaDifference />
      <VoicesOfResilience />
      <SecureYourStrategy />
      <PatientResources />
    </div>;
}